export const GREETING_GRADIENTS = {
	morning: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 55%, #A78BFA 100%)',
	afternoon: 'linear-gradient(135deg, #059669 0%, #0D9488 55%, #2DD4BF 100%)',
	evening: 'linear-gradient(135deg, #2563EB 0%, #0EA5E9 55%, #7DD3FC 100%)',
	night: 'linear-gradient(135deg, #0F172A 0%, #1E3A5F 55%, #334155 100%)',
}

export const GREETING_ICONS = {
	morning: 'sunrise',
	afternoon: 'sun',
	evening: 'dusk',
	night: 'moon',
}

/**
 * Morning — warm, purposeful (works with or without calendar).
 * Rotates randomly; consecutive visit avoids the last shown line.
 */
export const MORNING_MESSAGES = [
	// Client
	'The children are looking forward to seeing you today. Let’s begin.',
	'A new day. A fresh start. Someone needs your presence today — and you’ve got it.',
	'Good morning. The most important thing you can do today is show up fully. You already are.',
	'Every morning you log in, a child somewhere gets a little luckier. Let’s go.',
	'Today’s sessions haven’t happened yet. Anything is possible. Begin well.',
	'You chose this work because it matters. Today it matters again. Good morning.',
	'The day is fresh. So are you. Let’s make it count.',
	'Someone is going to feel heard today because of you. That’s worth getting out of bed for.',
	// MyPeegu
	'Your calm today becomes a child’s safety. Start gently, start present.',
	'Small check-ins. Big impact. Good morning — you’ve got this.',
	'Before the first session, take one quiet breath that is just yours.',
	'Presence over perfection. That’s the work. Welcome to today.',
]

/** Busy morning with several sessions before lunch */
export const MORNING_HEAVY_MESSAGES = [
	'You have a full morning ahead. The work you do today will stay with a child for a long time.',
	'A packed morning of holding space. Pace yourself — you’re needed all the way through.',
	'Several sessions before noon. Presence is your superpower today.',
	'A full morning. Remember: you matter too. Take water between students.',
]

/** Quieter morning */
export const MORNING_LIGHT_MESSAGES = [
	'A quieter morning. A good time to catch up on notes — or just breathe.',
	'Lighter load today. Use the space well.',
	'A gentler start. Sometimes that’s exactly what you and your students need.',
	'Space in the diary is a gift. Protect a little of it for yourself too.',
]

export const MONDAY_MORNING_MESSAGES = [
	'A new week. A fresh start. The children who come to you this week are counting on your presence.',
	'Monday energy, counsellor edition: show up kindly, one student at a time.',
	'New week, same purpose. You’ve got this — and they’ve got you.',
]

/**
 * Afternoon — light, human, slight smile, quick.
 */
export const AFTERNOON_MESSAGES = [
	// Client
	'Half marathon done! The second half is always the best part.',
	'Halfway there. You’ve earned a biscuit. Maybe two.',
	'Afternoon already? Time flies when you’re changing lives.',
	'The morning survived you. Now let’s see what the afternoon brings.',
	'Second half of the day. You’re still here. That says everything.',
	'Half done. Not half-hearted. Never that.',
	'Afternoon check-in: still standing? Good. Carry on.',
	'The morning called. It said you were brilliant. The afternoon is next.',
	'You’ve already made a difference today and it isn’t even evening yet.',
	'Midday energy is its own kind of magic. Tap into yours.',
	// MyPeegu
	'One more student. One more moment of being truly heard. You’ve got this.',
	'Afternoon stretch: soft shoulders, full attention, kind pace.',
	'Still in the room. Still showing up. That’s the quiet heroism of this work.',
	'Halfway through — and every session still gets your best presence.',
]

export const FRIDAY_AFTERNOON_MESSAGES = [
	'Friday afternoon. The week is almost done — and what you did this week mattered.',
	'End of the week coming. Finish kindly, then rest well.',
	'Friday you: still present, still patient. The weekend can wait a little longer.',
]

export const FLAGGED_MESSAGES = [
	'One of your students needs extra care today. Trust your training — and your instincts.',
	'Some days ask more of us. Today might be one of them. You’re not alone in this.',
	'A student may need a little more of you today. Slow down. Listen. You’ve done this before.',
]

/**
 * Evening — gentle, closing, care without pressure.
 */
export const EVENING_MESSAGES = [
	// Client
	'The day is wrapping up. So can you, soon.',
	'Evening. The hardest work is done. The notes can wait five minutes — breathe first.',
	'You showed up today. Fully. That is enough.',
	'The children you sat with today carried something heavy. Thank you for helping them carry it.',
	'Almost done. Close your notes, close your laptop, and close the day with kindness to yourself.',
	'Evening already. You made it through — and so did the students who needed you.',
	'The day is done. Rest is not a reward. It is part of the work.',
	'Sign off knowing today mattered. Because it did.',
	'Before you close — did you drink water today? Just checking.',
	'Good evening. The platform will be here tomorrow. You need to rest.',
	// MyPeegu
	'Leave the day a little softer than you found it — starting with yourself.',
	'Evening light. Soft landings. You’ve done enough for today.',
]

export const EVENING_COMPLETE_MESSAGES = [
	'Sessions done. Before you close your notes, take one breath that is just yours.',
	'The children you supported today were lucky to have you.',
	'A full day done. Document what matters, then rest.',
	'All sessions complete. Kindness to students includes kindness to you — clock off gently.',
	'You held space today. Now let the day hold you for a moment.',
]

export const LATE_LOGIN_MESSAGES = [
	'Still here this late? The notes will wait five minutes. Take a moment first.',
	'Late hours don’t earn extra points. Rest does. Wrap up kindly.',
	'The work will be here tomorrow. You need sleep more than one more click.',
]

export const NIGHT_MESSAGES = [
	'Quiet hours. Rest is part of the work too.',
	'The day can wait until morning. Sign off with care.',
	'Night mode for counsellors: soft lights, soft endings, real rest.',
	'MyPeegu will be here tomorrow. Tonight is for you.',
]
